import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from '../lib/theme';
import { cn } from '../lib/cn';

export function ThemeToggle() {
  const { mode, setMode } = useTheme();

  const Item = (props: { value: typeof mode; icon: React.ReactNode; label: string }) => {
    const active = mode === props.value;
    return (
      <button
        type="button"
        onClick={() => setMode(props.value)}
        aria-pressed={active}
        title={props.label}
        className={cn(
          'w-7 h-7 grid place-items-center rounded-md transition',
          active
            ? 'bg-white dark:bg-zinc-700 text-zinc-950 dark:text-zinc-50 shadow-xs'
            : 'text-zinc-500 dark:text-zinc-400 hover:text-zinc-950 dark:hover:text-zinc-100',
        )}
      >
        {props.icon}
      </button>
    );
  };

  return (
    <div className="inline-flex items-center gap-0.5 p-0.5 rounded-md bg-zinc-100 dark:bg-zinc-800">
      <Item value="light" icon={<Sun className="w-3.5 h-3.5" />} label="Light" />
      <Item value="system" icon={<Monitor className="w-3.5 h-3.5" />} label="System" />
      <Item value="dark" icon={<Moon className="w-3.5 h-3.5" />} label="Dark" />
    </div>
  );
}
